export const upper = (value: any) => value && value.toUpperCase();
export const lower = (value: any) => value && value.toLowerCase();
export const number = (value: any) => value && value.replace(/\D/g, '');
export const maxChars = (max: any) => (value: any) => value && value.substring(0, max);
export const normalizeOTP = (value: any) => value && maxChars(6)(number(value));
